import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./OurAwards.css";

const OurAwards = () => {
  return (
    <>
      <div className="our-awards">
        <h1 className="headings text-center">
          <span>Our</span> Prestigious Recognitions
        </h1>
        <div className="container">
          <div className="row px-lg-5 mt-md-5 mt-3 gap-3 gap-md-0 px-md-0 px-3">
            <div className="col-md-4">
              <div className="card award-card ">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/icons/Awards%20Logo/Artboard%201%20copy%202.svg"
                  className="card-img-top"
                  alt="..."
                  loading="lazy"
                />
                <div className="card-body award-card-body grotesk-headings bg-white">
                  <p className="head-award">Amadeus Top Performer - 2023 </p>
                  {/* <p className='content-award'>International Travel Awards</p> */}
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card award-card ">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/icons/Awards%20Logo/Artboard%201%20copy%203.svg"
                  className="card-img-top"
                  alt="..."
                  loading="lazy"
                />
                <div className="card-body award-card-body grotesk-headings bg-white">
                  <p className="head-award text-capitalize">
                    Gold Award from Qatar Airways
                  </p>
                  {/* <p className='content-award'>International Travel Awards</p> */}
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card award-card ">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/icons/Awards%20Logo/Artboard%201%20copy%207.svg"
                  className="card-img-top"
                  alt="..."
                  loading="lazy"
                />
                <div className="card-body award-card-body grotesk-headings bg-white">
                  <p className="head-award">
                    Fastest Growing Travel Company by Arabian Travel Awards 2024
                  </p>
                  {/* <p className='content-award'>International Travel Awards</p> */}
                </div>
              </div>
            </div>
          </div>

          <div className="row px-lg-5 mt-md-5 mt-3 gap-3 gap-md-0 px-md-0 px-3">
            <div className="col-md-4">
              <div className="card award-card ">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/icons/Awards%20Logo/Artboard%201%20copy%206.svg"
                  className="card-img-top"
                  alt="..."
                  loading="lazy"
                />
                <div className="card-body award-card-body grotesk-headings bg-white">
                  <p className="head-award">
                    Royal Air Maroc awarded in 2023 As a Best Partner
                  </p>
                  {/* <p className='content-award'>International Travel Awards</p> */}
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card award-card ">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/icons/Awards%20Logo/Artboard%201%20copy%204.svg"
                  className="card-img-top"
                  alt="..."
                  loading="lazy"
                />
                <div className="card-body award-card-body grotesk-headings bg-white">
                  <p className="head-award">
                    World Travel Awards 2024 - Leading Travel Agency
                  </p>
                  {/* <p className='content-award'>International Travel Awards</p> */}
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card award-card ">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/icons/Awards%20Logo/Artboard%201%20copy%205.svg"
                  className="card-img-top"
                  alt="..."
                  loading="lazy"
                />
                <div className="card-body award-card-body grotesk-headings bg-white">
                  <p className="head-award">
                    Air Mauritius Top Performer - 2023-24
                  </p>
                  {/* <p className='content-award'>International Travel Awards</p> */}
                </div>
              </div>
            </div>
          </div>

          <div className="row px-lg-5 mt-md-5 mt-3 gap-3 gap-md-0 px-md-0 px-3">
            <div className="col-md-4">
              <div className="card award-card ">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/icons/Awards%20Logo/Artboard%201%20copy%2030.svg"
                  className="card-img-top"
                  alt="..."
                  loading="lazy"
                />
                <div className="card-body award-card-body grotesk-headings bg-white">
                  <p className="head-award">
                    IATA Certificate of Accreditation
                  </p>
                  {/* <p className='content-award'>International Travel Awards</p> */}
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card award-card ">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/icons/Awards%20Logo/Artboard%201%20copy%209.svg"
                  className="card-img-top"
                  alt="..."
                  loading="lazy"
                />
                <div className="card-body award-card-body grotesk-headings bg-white">
                  <p className="head-award">
                    Ethiopian Airline Top performer - 2023-24{" "}
                  </p>
                  {/* <p className='content-award'>International Travel Awards</p> */}
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card award-card ">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/icons/Awards%20Logo/Artboard%201%20copy%2010.svg"
                  className="card-img-top"
                  alt="..."
                  loading="lazy"
                />
                <div className="card-body award-card-body grotesk-headings bg-white">
                  <p className="head-award">
                    For Exemplary Business Contribution Award 2023-2024
                  </p>
                  {/* <p className='content-award'>International Travel Awards</p> */}
                </div>
              </div>
            </div>
          </div>

          <div className="row px-lg-5 mt-md-5 mt-3 gap-3 gap-md-0 px-md-0 px-3">
            <div className="col-md-4">
              <div className="card award-card ">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/icons/Awards%20Logo/Artboard%201%20copy%2011.svg"
                  className="card-img-top"
                  alt="..."
                  loading="lazy"
                />
                <div className="card-body award-card-body grotesk-headings bg-white">
                  <p className="head-award">Top Seller Award</p>
                  {/* <p className='content-award'>International Travel Awards</p> */}
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card award-card ">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/icons/Awards%20Logo/Artboard%201%20copy%2012.svg"
                  className="card-img-top"
                  alt="..."
                  loading="lazy"
                />
                <div className="card-body award-card-body grotesk-headings bg-white">
                  <p className="head-award">Best Seller Award</p>
                  {/* <p className='content-award'>International Travel Awards</p> */}
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card award-card ">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/icons/Awards%20Logo/Artboard%201%20copy%2013.svg"
                  className="card-img-top"
                  alt="..."
                  loading="lazy"
                />
                <div className="card-body award-card-body grotesk-headings bg-white">
                  <p className="head-award">
                    Certificate of Appreciation 2023 Brussels Airlines Ghana
                  </p>
                  {/* <p className='content-award'>International Travel Awards</p> */}
                </div>
              </div>
            </div>
          </div>

          <div className="row px-lg-5 mt-md-5 mt-3 gap-3 gap-md-0 px-md-0 px-3">
            <div className="col-md-4">
              <div className="card award-card ">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/icons/Awards%20Logo/Artboard%201%20copy%2014.svg"
                  className="card-img-top"
                  alt="..."
                  loading="lazy"
                />
                <div className="card-body award-card-body grotesk-headings bg-white">
                  <p className="head-award">Top sellers in GDS Travelport</p>
                  {/* <p className='content-award'>International Travel Awards</p> */}
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card award-card ">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/icons/Awards%20Logo/Artboard%201%20copy%2020.svg"
                  className="card-img-top"
                  alt="..."
                  loading="lazy"
                />
                <div className="card-body award-card-body grotesk-headings bg-white">
                  <p className="head-award">
                    Distinguished representation & continued support{" "}
                  </p>
                  {/* <p className='content-award'>International Travel Awards</p> */}
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card award-card ">
                <LazyLoadImage
                  effect="blur"
                  src="https://blueberrywebsites.azureedge.net/bbt/icons/Awards%20Logo/Artboard%201%20copy%2016.svg"
                  className="card-img-top"
                  alt="..."
                  loading="lazy"
                />
                <div className="card-body award-card-body grotesk-headings bg-white">
                  <p className="head-award">
                    Air Tanzania Certificate Of Appreciation{" "}
                  </p>
                  {/* <p className='content-award'>International Travel Awards</p> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OurAwards;
